export type IcFooterBreakpoints =
  | "extra small"
  | "small"
  | "medium"
  | "large"
  | "extra large";
